module.exports = __webpack_public_path__ + "img/TZS09385.1b453ad8.jpeg";